import LText from "@components/LText";
import ModalBackButton from "@components/ModalBackButton";
import { Stack } from "expo-router";

export default function AccessesStack() {
  return (
    <Stack
      screenOptions={{
        title: "Create Access",
        headerShown: true,
        headerTitleAlign: "center",
        headerBackVisible: false,
        headerLeft: () => <ModalBackButton />,
        headerRight: () => null,
        headerTitle: () => (
          <LText variant="h1" textAlign="center">
            Create Access
          </LText>
        ),
        headerTransparent: true,
        headerShadowVisible: false,
        headerTitleStyle: {
          color: "white",
        },
      }}
    >
      <Stack.Screen
        name="allocate"
        options={{
          headerTitle: () => (
            <LText variant="h1" textAlign="center">
              Edit Access
            </LText>
          ),
        }}
      />
      <Stack.Screen
        name="video-call"
        options={{
          headerLeft: () => null,
          headerTitle: () => (
            <LText variant="h1" textAlign="center">
              Talk
            </LText>
          ),
        }}
      />
    </Stack>
  );
}
